<template>
  <div style="padding: 0 24px 26px 24px ">
    <search-list @findData="findData" ></search-list>
    <Button type="primary" class="mb16" @click.stop="toAdd"
            v-p="{api:'role/add'}"
    >添加</Button>
    <Button type="primary" class="mb16" @click.stop="toQuickConfig"
            v-p="{api:'role/addRolePermission'}"
    >快捷配置</Button>

    <table-list
      title="" :columns="columns" :data="dataTable"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
    ></table-list>
    <add :n="addN" @done="rolelist(searched)"></add>
    <quick-config :n="quickN" @done="quickDone"></quick-config>
    <update :n="updateN" :id="updateId" :appType="appType" @done="rolelist(searched)"></update>
  </div>
</template>
<script>
  import SearchList from './components/SearchList'
  import TableList from "components/TableList/index";
  import Add from './components/Add'
  import QuickConfig from './components/QuickConfig'
  import {rolelist,roleblockUp,roledelete} from "../../../api/character";
  import Update from './components/Update'
  import {formatDateTime} from '@/utils/format'


  export default {
    name: "character",
    components:{
      SearchList,
      TableList,
      Add,
      QuickConfig,
      Update
    },

    data(){
      return {
        updateId:'',
        appType:null,
        updateN:0,
        quickN:0,
        addN:0,
        page:1,
        current: 1,
        total: 0,
        dataTable: [],
        loading: false,
        columns:[
          {
            type:'index',
            width:60,
          },

          {
            title:'角色名称',
            key:'roleName',
            align:'center'
          },
          {
            title:'角色类型',
            key:'roleType',
            align:'center',
            render:(h,params)=>{
              return h('span',{},params.row['roleType']===1?'平台角色':(params.row['roleType']===2?'企业角色':'-'))
            }

          },
          {
            title:'所属机构',
            key:'orgName',
            align:'center'

          },
          {
            title:'所属应用',
            key:'isZyuName',
            align:'center',
            // render:(h,params)=>{
            //   return h('span',{},params.row['isZyu']==='1'?'自如寓':'超级ZO')
            // }

          },
          {
            title:'创建人',
            key:'creatorName',
            align:'center'
          },
          {
            title:'修改时间',
            key:'modifyTime',
            align:'center',
            render:(h,params) => {
              return h('span',formatDateTime(params.row.modifyTime,true))
            }

          },
          {
            title:'状态',
            key:'status',
            align:'center',
            render:(h,params)=>{
              return h('span',{},params.row['status']===1?'禁用':'启用')
            }

          },
          {
            title:'操作',
            key:'actions',
            align:'center',
            width:150,
            render:(h,params)=>{
              let editItem=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'role/edit'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    // this.appType=(params.row['isZyu'] === '1')?1:2;
                    this.appType=+params.row['isZyu']

                    this.updateId=params.row['id'];
                    this.updateN++
                  }
                }

              },'修改');
              let stopItem=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'role/blockUp'
                    }
                  }
                ],
                style:{
                  marginLeft:'10px'
                },
                on:{
                  click:()=>{
                    this.$Modal.confirm({
                      title: '',
                      content: params.row['status']===0?'<p>确定要停用该角色吗，停用后该角色下的所有账号将无法正常使用！</p>':'<p>确定要启用该角色吗？</p>',
                      onOk: () => {
                        roleblockUp({
                          id:params.row['id'],
                          status:params.row['status']===1?0:1
                        }).then(res=>{
                          this.$Message.success('操作成功!');
                          this.rolelist(this.searched)
                        }).catch(error=>{})
                      }
                    })
                  }
                }
              },params.row['status']===0?'禁用':'启用');
              let deleteItem=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'role/delete'
                    }
                  }
                ],
                style:{
                  marginLeft:'10px',
                  opacity: params.row['status']===1?1:0.3
                },
                on:{
                  click:()=>{
                    if(params.row['status']===1){
                      this.$Modal.confirm({
                        title: '',
                        content: '<p>确定要删除该角色吗，删除后该角色下的所有账号将无法正常使用！</p>',
                        onOk: () => {
                          roledelete({
                            id:params.row['id'],
                            roleCode:params.row['roleCode'],
                          }).then(res=>{
                            this.$Message.success('操作成功!');
                            this.findData(this.searched)
                          }).catch(error=>{})
                        }
                      })
                    }else{
                      return false;
                    }
                  }
                }
              },'删除');
              return h('div',{},[editItem,stopItem,deleteItem])
            }
          },
        ],
        searched:null,
      }

    },
    methods:{
      quickDone(){
        this.rolelist(this.searched)
      },
      findData(data){
        this.page=1;
        this.current=1;
        if(data.appType == ''){
          data.appType = null
        }
        this.rolelist(data)
      },
      rolelist(data){
        let params={
          ...data,
          page:this.page,
          limit:10
        };
        rolelist(params).then(res=>{
          if(!res.data){
            return
          }
          this.dataTable=res.data.rows;
          this.total=res.data.total;
          this.searched=params
        }).catch(error=>{})
      },

      toQuickConfig(){
        this.quickN++
      },
      toAdd(){
        this.addN++

      },
      changePage(n){
        this.current = n;
        this.page = n;
        this.rolelist(this.searched)

      }

    }
  }
</script>

<style scoped>

</style>
